export function FileUploadedIcon(): JSX.Element {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M19.0438 10.5977H9.427C8.53699 10.5977 7.81567 11.319 7.81567 12.209C7.81567 13.099 8.53699 13.8203 9.427 13.8203H19.0438C19.9334 13.8203 20.6551 13.099 20.6551 12.209C20.6551 11.319 19.9334 10.5977 19.0438 10.5977Z"
          fill="currentColor"
        />
        <path
          d="M19.0438 17.043H9.427C8.53699 17.043 7.81567 17.7643 7.81567 18.6543C7.81567 19.5443 8.53699 20.2656 9.427 20.2656H19.0438C19.9334 20.2656 20.6551 19.5443 20.6551 18.6543C20.6551 17.7643 19.9334 17.043 19.0438 17.043Z"
          fill="currentColor"
        />
        <path
          d="M19.0438 23.4883H9.427C8.53699 23.4883 7.81567 24.2096 7.81567 25.0996C7.81567 25.9896 8.53699 26.7109 9.427 26.7109H19.0438C19.9334 26.7109 20.6551 25.9896 20.6551 25.0996C20.6551 24.2096 19.9334 23.4883 19.0438 23.4883Z"
          fill="currentColor"
        />
        <path
          d="M19.0438 29.9336H9.427C8.53699 29.9336 7.81567 30.6549 7.81567 31.5449C7.81567 32.4349 8.53699 33.1562 9.427 33.1562H19.0438C19.9334 33.1562 20.6551 32.4349 20.6551 31.5449C20.6551 30.6549 19.9334 29.9336 19.0438 29.9336Z"
          fill="currentColor"
        />
        <path
          d="M19.0438 36.4883H9.427C8.53699 36.4883 7.81567 37.21 7.81567 38.0996C7.81567 38.9896 8.53699 39.7109 9.427 39.7109H19.0438C19.9334 39.7109 20.6551 38.9896 20.6551 38.0996C20.6551 37.21 19.9334 36.4883 19.0438 36.4883Z"
          fill="currentColor"
        />
        <path
          d="M24.4553 13.8203H34.0721C34.9621 13.8203 35.6834 13.099 35.6834 12.209C35.6834 11.319 34.9621 10.5977 34.0721 10.5977H24.4553C23.5657 10.5977 22.844 11.319 22.844 12.209C22.844 13.099 23.5657 13.8203 24.4553 13.8203Z"
          fill="currentColor"
        />
        <path
          d="M24.4553 20.2656H34.0721C34.9621 20.2656 35.6834 19.5443 35.6834 18.6543C35.6834 17.7643 34.9621 17.043 34.0721 17.043H24.4553C23.5657 17.043 22.844 17.7643 22.844 18.6543C22.844 19.5443 23.5657 20.2656 24.4553 20.2656Z"
          fill="currentColor"
        />
        <path
          d="M30.6984 25.0996C30.6984 24.2096 29.9771 23.4883 29.0871 23.4883H24.4553C23.5657 23.4883 22.844 24.2096 22.844 25.0996C22.844 25.9896 23.5657 26.7109 24.4553 26.7109H29.0871C29.9771 26.7109 30.6984 25.9896 30.6984 25.0996Z"
          fill="currentColor"
        />
        <path
          d="M45.9627 37.167C45.2686 36.6102 44.2548 36.7214 43.6976 37.4154L39.5476 42.5893L36.9782 40.7279C36.2578 40.2055 35.2498 40.3666 34.7278 41.0871C34.2058 41.808 34.367 42.8155 35.0874 43.3375L38.8988 46.099C39.1842 46.3054 39.5148 46.4057 39.8434 46.4057C40.3163 46.4057 40.7837 46.198 41.101 45.8023L46.2115 39.4321C46.7683 38.7381 46.6571 37.7239 45.9627 37.167Z"
          fill="currentColor"
        />
        <path
          d="M50.0355 32.2203C47.9366 30.0844 45.2397 28.7383 42.3175 28.3418V6.48937C42.3175 2.9113 39.4062 0 35.8281 0H7.67143C4.09294 0 1.18164 2.9113 1.18164 6.48937V43.8155C1.18164 47.394 4.09294 50.3053 7.67101 50.3053H30.3173C32.8656 53.2989 36.5297 55 40.4939 55C47.8728 55 53.8759 48.9928 53.8759 41.6088C53.8759 38.0739 52.5121 34.7396 50.0355 32.2203ZM4.4043 43.8155V6.48937C4.4043 4.68838 5.87002 3.22266 7.67143 3.22266H35.8281C37.6296 3.22266 39.0949 4.68838 39.0949 6.48937V28.2906C32.3709 28.9926 27.1119 34.6973 27.1119 41.6088C27.1119 43.5243 27.5113 45.3765 28.2776 47.0823H7.67143C5.87002 47.0823 4.4043 45.617 4.4043 43.8155ZM40.4939 51.7773C37.2758 51.7773 34.3175 50.2999 32.3768 47.7243C31.0407 45.9505 30.3341 43.8361 30.3341 41.6088C30.3341 36.0019 34.892 31.4402 40.4939 31.4402C40.5467 31.4402 40.6 31.441 40.6529 31.4419L40.6776 31.4423C43.3519 31.4897 45.8591 32.5681 47.7373 34.4791C49.6176 36.3921 50.6532 38.9245 50.6532 41.6088C50.6532 47.2157 46.0957 51.7773 40.4939 51.7773Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="55" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
